import { useQueries, useQuery } from "@tanstack/react-query";
import http from "../utils/http";

export const useFetchTrackingByNumber = (number) => {
    return useQuery({
        queryKey: ["trackings", number],
        queryFn: () => http.get(`/tracking?number=${number}`).then(res => res.data),
        enabled: !!number,
    });
}

export const useFetchTrackingById = (id) => {
    return useQuery({
        queryKey: ["tracking", "id", id],
        queryFn: () => http.get(`/tracking/${id}`).then(res => res.data),
        enabled: !!id,
    });
}

export const useFetchTrackingEvents = (id) => {
    return useQuery({
        queryKey: ["tracking-events", id],
        queryFn: () => http.get(`/tracking/${id}/event`).then(res => res.data),
        enabled: !!id,
        placeholderData: []
    });
}

export const useFetchMultipleTrackingEvents = (ids = []) => {
    return useQueries({
        queries: ids.map(id => ({
            queryKey: ["tracking-events", id],
            queryFn: () => http.get(`/tracking/${id}/event`).then(res => res.data),
            enabled: !!id,
            placeholderData: [],
            
        }))
    });
};